import { connectionTypeLabel } from './product';

export default function InternetMixins() {
    return {
        methods: {
            connectionTypeLabel(typeSlug) {
                return connectionTypeLabel(typeSlug);
            },
        },
    };
}
